import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import { AuthProvider } from "./lib/auth";
import { installChunkRecovery } from "./lib/chunkRecovery";
import { ToastProvider } from "./components/ui";
import App from "./App";
import "./styles/globals.css";

/**
 * Point d'entrée SPA Etheria (WS5).
 * Ordre des providers : Query → Auth (dépend de Query via /api/auth/me) → Toast → Router → App.
 */
const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Élément #root introuvable dans index.html");

installChunkRecovery();

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ToastProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ToastProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
